import { TIPOS_ARQUIVOS } from "../ListaArquivos/TiposArquivos/TiposArquivosEnum";

export default {
  data() {
    return {
      arquivoIsValido: false,
      arquivosAceito: {
        pdf: ".pdf",
        png: ".png",
        jpg: ".jpg",
        jpeg: ".jpeg",
        zip: ".zip",
        _7z: ".7z",
        rar: ".rar"
      }
    };
  },
  methods: {
    /**
     * @param { File } arquivo
     */
    salvarArquivo(arquivo) {
      const { name, size } = arquivo;
      console.log("singular_vue salvar_arquivo", arquivo);
      this.arquivoIsValido = false;

      this.verificaTamanhoArquivo(arquivo);

      if (this.arquivoIsValido) {
        const objetoArquivoUpload = this.criarObjetoArquivo(
          name,
          size,
          TIPOS_ARQUIVOS.UPLOAD
        );
        let formData = new FormData();
        formData.append("uploadAnexo", arquivo);
        this.$emit("upload-arquivo", { formData, objetoArquivoUpload });
      }
    },
    criarObjetoArquivo(nome, tamanho, tipo) {
      return {
        tipoArquivo: tipo,
        objetoArquivo: {
          nomeArquivo: nome,
          tamanhoArquivo: this.formatarBytes(tamanho),
          descricao: "",
          barraProgresso: 0,
          id: 1
        }
      };
    },
    carregarArquivoParaDescricao(arquivo) {
      this.$emit("arquivo-para-descricao", arquivo);
    },
    erroArquivo(extensao, tamanho) {
      if (extensao) {
        this.$emit(
          "abril-Modal-Warn",
          true,
          this.mensagemErroTamanhoArquivo(extensao, tamanho)
        );
        return;
      }
      this.$emit(
        "abril-Modal-Warn",
        true,
        "Tamanho do arquivo não suportado para sua extensão"
      );
    },
    verificaTamanhoArquivo(arquivo) {
      const pdf = arquivo.name.includes(this.arquivosAceito.pdf);

      const imagem =
        arquivo.name.includes(this.arquivosAceito.png) ||
        arquivo.name.includes(this.arquivosAceito.jpg) ||
        arquivo.name.includes(this.arquivosAceito.jpeg);

      const zip =
        arquivo.name.includes(this.arquivosAceito.zip) ||
        arquivo.name.includes(this.arquivosAceito.rar) ||
        arquivo.name.includes(this.arquivosAceito._7z);
      if (pdf) {
        this.validarTamanhoArquivo(arquivo, "pdf");
      } else if (imagem) {
        this.validarTamanhoArquivo(arquivo, "imagem");
      } else if (zip) {
        this.validarTamanhoArquivo(arquivo, "zip");
      }
    },
    validarTamanhoArquivo(arquivo, extensao) {
      switch (extensao) {
        case "imagem":
          if ((arquivo.size / 1024).toFixed(2) >= 2100) {
            this.erroArquivo(extensao, "2mb");
            console.log(
              "teste de tamanho de arquivo imagem",
              (arquivo.size / 1024).toFixed(2)
            );
          } else {
            this.arquivoIsValido = true;
          }
          break;
        case "zip":
          if ((arquivo.size / 1024).toFixed(2) >= 20100) {
            this.erroArquivo(extensao, "20mb");
            console.log(
              "teste de tamanho de arquivo zip",
              (arquivo.size / 1024).toFixed(2)
            );
          } else {
            this.arquivoIsValido = true;
          }
          break;
        default:
          if ((arquivo.size / 1024).toFixed(2) >= 1100) {
            this.erroArquivo(extensao, "1100Kb");
            console.log(
              "teste de tamanho de arquivo pdf",
              (arquivo.size / 1024).toFixed(2)
            );
          } else {
            this.arquivoIsValido = true;
          }
          break;
      }
    },
    mensagemErroTamanhoArquivo(extensao, tamanho) {
      return `Para arquivo do tipo ${extensao} tem que ser tamanho menor ${tamanho})`;
    }
  }
};
